/**
 * Returns an object based on the keys and values included in a query string.
 *
 * @param {string} qs - The query string that needs to be parsed
 *
 * @example
 * const qs = '?x=abc&y=def';
 * const parsedQs = parseQueryStrings(qs);
 *
 * console.log(parsedQs); // { x: 'abc', y: 'def' }
 */

export type ObjectQueryParams =
  | {
      [key: string]: string | boolean;
    }
  | undefined;

const parseQueryStrings = (qs?: string): ObjectQueryParams => {
  if (!qs) {
    return;
  }
  const queryStrings = qs.replace('?', '').split('&');
  const parsedObject: {
    [key: string]: string | boolean;
  } = {};

  queryStrings.forEach(q => {
    const [key, ...rest] = q.split('=');

    const value = rest.length > 1 ? rest.join('=') : rest[0];

    /**
     * If we don't validate the keyAndValue[0] (key), we will get a { '': true } when qs is equal to "?&"
     */
    if (key) {
      parsedObject[key] = value || true;
    }
  });

  return parsedObject;
};

export default parseQueryStrings;
